import React from 'react';
import Counter from '../Counter/Counter';

import './ProductCart.scss';

import IconDelete from '../../../../static/images/icons/delete.svg';
import {CartController} from "../../../../helpers/CartController";

const ProductCart = ({item, setCart, updateCount}) => {
  const deleteProduct = () => {
    const resp = CartController.deleteFromCart(item.id);
    setCart(resp);
    updateCount();
  }

  return (
    <div className="product-cart">
      <div className="summary">
        <picture>
          <img src={item.image} alt="Producto" />
        </picture>

        <div className="information">
          <h4 className="name">{item.name}</h4>
          <p className="price" dangerouslySetInnerHTML={{__html: item.price}}></p>
        </div>
      </div>

      <div className="options">
        <button className="bt-delete" type="button">
          <img src={IconDelete} alt="Eliminar" onClick={deleteProduct} />
        </button>
        <Counter item={item} setCart={setCart}/>
      </div>
    </div>
  );
};

export default ProductCart;
